var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLandingStarterQuiz2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 218,
    height: 210,
    viewBox: "0 0 218 210",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "ancw3y2gma",
    x1: "0%",
    x2: "99.998%",
    y1: "49.991%",
    y2: "49.991%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#4E4D4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#020203"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "1jep8ocg9b",
    x1: ".004%",
    x2: "100.01%",
    y1: "49.993%",
    y2: "49.993%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#4E4D4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#020203"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ycs1ryi24c",
    x1: "-.001%",
    x2: "99.997%",
    y1: "49.998%",
    y2: "49.998%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#4E4D4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#020203"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h4l5e0i4nd",
    x1: "-.009%",
    x2: "99.993%",
    y1: "49.995%",
    y2: "49.995%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#4E4D4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#020203"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-425 -31) translate(425 31)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 101.583,
    cy: 196.193,
    fill: "#DEE0E9",
    rx: 101.524,
    ry: 13.537
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#6DA142",
    d: "M97.167 9.98C89.487 3.86 79.694.6 68.685.348l-.003-.004h-.212c-.816-.015-1.636-.018-2.463 0H49.021L55.478 1.4c-1.255.223-2.52.476-3.798.765-13.547 3.095-23.736 11.799-29.469 25.17-3.97 9.257-4.35 17.61-4.38 18.531-.09 2.813.842 5.422 2.463 7.467-1.91 1.625-9.124 4.336-9.124 4.336s12.186.793 18.095.007c6.084-.809 11.213-4.873 11.418-11.053.007-.186.794-18.673 16.097-22.17 10.961-2.506 20.243-1.295 26.14 3.406 4.863 3.878 7.329 10.064 7.332 18.388 0 9.698-11.985 18.834-22.558 26.893C57.57 80.854 48.83 87.516 46.478 97.057c-3.82 15.498-3.051 32.971-3.018 33.706.099 2.1.757 4.036 1.825 5.678-.98 1.35-7.57 3.066-8.125 5.2l17.71.01c.18 0 .36-.003.535-.01 6.304-.29 11.177-5.639 10.891-11.942-.007-.125-.46-10.833 1.248-21.534.655-4.098 2.788-7.811 5.956-10.493 2.554-2.162 5.62-4.496 8.049-6.348 13.32-10.152 31.57-24.054 31.566-45.08-.008-15.194-5.671-28.072-15.948-36.264zM47.093 146.085c-2.302-.428-7.083-.867-11.353.421l.549 28.346s7.62.696 11.923.107c.395-.055.794-.1 1.193-.118 6.062-.285 10.888-5.286 10.888-11.418v-5.495c0-5.802-4.325-10.599-9.93-11.334-1.093-.146-2.184-.304-3.27-.509z",
    transform: "translate(103.17)"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#7FBC4D"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.152 141.648c-6.065 0-11.122-4.768-11.407-10.888-.033-.736-.805-18.209 3.018-33.706 2.353-9.542 11.093-16.204 21.216-23.916 10.573-8.06 22.562-17.192 22.559-26.894 0-8.327-2.466-14.514-7.332-18.388-5.897-4.701-15.18-5.908-26.14-3.406-15.3 3.498-16.09 21.984-16.098 22.17-.205 6.18-5.279 11.053-11.418 11.053-.128 0-.256-.003-.384-.007C4.855 57.457-.088 52.17.12 45.863c.029-.922.413-9.274 4.379-18.53C10.233 13.965 20.422 5.26 33.97 2.163 51.852-1.925 68.005.848 79.452 9.976 89.73 18.168 95.392 31.05 95.396 46.24 95.4 67.266 77.155 81.168 63.83 91.32c-2.429 1.852-5.495 4.186-8.048 6.348-3.169 2.682-5.302 6.395-5.956 10.493-1.709 10.705-1.255 21.41-1.248 21.534.285 6.304-4.591 11.649-10.891 11.942-.18.007-.359.01-.535.01zM36.289 174.852c-6.315 0-11.43-5.118-11.43-11.429v-5.495c0-6.315 5.119-11.43 11.43-11.43 6.315 0 11.43 5.12 11.43 11.43v5.495c.003 6.311-5.115 11.43-11.43 11.43z",
    transform: "translate(103.17)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#ancw3y2gma)",
    d: "M10.013 19.965S19.511 3.538 45.596 1.123C71.678-1.29 81.022 15.45 81.022 15.45S58.13 5.48 39.523 10.427c-18.607 4.946-24.216 16.39-27.252 15.691-3.037-.706-5.034-2.517-2.258-6.153z",
    transform: "translate(103.17)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#1jep8ocg9b)",
    d: "M4.562 31.566S.344 41.646 2.071 48.15c1.727 6.505 7.397 9.11 11.056 7.632 3.658-1.482-8.565-24.216-8.565-24.216z",
    transform: "translate(103.17)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#ycs1ryi24c)",
    d: "M31.423 130.215c-.33 1.642-2.641 1.745-3.113.139-.322-1.105-.542-2.345-.505-3.644.117-4.438 1.054-29.48 4.32-34.687 6.89-10.98 37.607-32.674 39.36-35.839 1.752-3.168 7.825-9.241 6.19-1.65-1.636 7.592-19.504 24.527-24.06 28.145-4.554 3.622-13.43 5.84-17.747 25.99-1.646 7.68-3.406 16.35-4.445 21.546z",
    transform: "translate(103.17)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#h4l5e0i4nd)",
    d: "M33.761 147.691s-5.294 1.559-6.93 5.997c-1.635 4.438-2.022 13.588 1.208 16.196 3.23 2.605 14.404-23.634 5.722-22.193z",
    transform: "translate(103.17)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#8D2E64",
    d: "M57.146 63.377s14.763 1.101 20.54-10.014c5.776-11.114-3.784-18.962-3.784-18.962S49.42 54.611 57.146 63.377z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M9.38.048s.557 5.77-.31 7.302c.387.487 1.057.97 2.202 1.024 1.302.066 3.805-.128 5.96-.526-.542-2.283-.545-6.34-.6-7.625L9.38.048z",
    transform: "translate(97.317 187.317)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M10.69 4.95c-3.929.161-8.334-.296-10.518-.57-.059.233-.106.486-.12.786-.07 1.416 14.275 2.07 16.755.83.666-.333 1.003-1.068 1.072-1.968-1.866.392-4.43.809-7.189.922z",
    transform: "translate(97.317 187.317) translate(0 7.317)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#211B40",
    d: "M10.69 4.95c2.759-.113 5.323-.53 7.19-.918.069-.853-.1-1.852-.45-2.8-.078-.204-.143-.445-.206-.705-2.154.399-4.653.593-5.96.527C10.125.999 9.455.512 9.063.029c-.018.033-.04.07-.058.099-.417.596-1.57.999-3.158 1.577C3.55 2.744.776 2.023.168 4.379c2.188.275 6.593.732 10.522.571z",
    transform: "translate(97.317 187.317) translate(0 7.317)"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M9.494.048s.556 5.77-.311 7.302c.388.487 1.057.97 2.202 1.024 1.303.066 3.805-.128 5.96-.526-.541-2.283-.545-6.34-.6-7.625L9.494.048z",
    transform: "translate(73.17 187.317)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M10.804 4.95c-3.93.161-8.334-.296-10.519-.57-.062.233-.106.486-.12.786-.07 1.416 14.275 2.07 16.756.83.666-.333 1.002-1.068 1.072-1.968-1.866.392-4.43.809-7.19.922z",
    transform: "translate(73.17 187.317) translate(0 7.317)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#211B40",
    d: "M10.804 4.95c2.758-.113 5.323-.53 7.189-.918.07-.853-.1-1.852-.45-2.8-.077-.204-.143-.445-.205-.705-2.155.399-4.654.593-5.96.527C10.237.999 9.568.512 9.176.029c-.019.033-.04.07-.059.099-.417.596-1.57.999-3.157 1.577C3.662 2.744.889 2.023.282 4.379c2.188.275 6.592.732 10.522.571z",
    transform: "translate(73.17 187.317) translate(0 7.317)"
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "#211B40",
    d: "M73.595 58.452c1.372-1.148 2.623-2.56 3.648-4.298-1.438-4.621-2.971-9.286-3.648-10.45v14.748z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EC6265",
    d: "M77.865 24.904s2.133-1.27 2.948-1.577c.813-.307 2.861-.728 1.369-1.336-1.493-.607-2.642.593-2.927-.574-.285-1.167.808-2.568 1.697-5.07.41-1.153-2.3-1.779-3.991.54-2.016 2.77-2.846 5.383-2.44 6.864.87 3.198 3.344 1.153 3.344 1.153z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#006E49",
    d: "M79.562 80.268c14.62 2.722 29.565 1.786 35.349 1.255.362 1.376 4.248 2.601 4.317 4.197.582 13.584-.651 44.465-.651 44.465s.589 42.388-1.83 58.709c-.131.889-.834 1.58-1.726 1.69-3.516.425-9.897 1.178-10.471-.827-4.028-14.103-5.484-36.234-7.467-50.956-.907-6.742-1.588-19.427-2.704-29.147-.208-1.833-.786-5.009-1.028-3.18l-4.818 29.393s6.497 48.78 2.967 53.016c-1.884 2.26-13.193 2.25-13.504 0-2.074-15.007-11.147-43.73-5.967-73.23.801-4.587 5.74-31.035 7.533-35.385z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M120.805 41.828c.066-8.576-3.618-13.954-17.265-17.133-13.525-3.15-25.803-.106-28.277 5.576-4.181 9.614-.362 17.26.286 26.857.808 12.022.658 25.05.527 30.922-.037 1.661 1.42 2.96 3.065 2.733 4.76-.651 13.574-1.701 16.874-1.065 4.287.827 14.689 5.29 20.564 7.903 1.987.881 4.222-.571 4.219-2.744-.008-12.699-.037-47.4.007-53.049z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EC6265",
    d: "M89.228 24.662s5.016-1.328 7.994-.475c2.978.852.9 6.552-1.815 7.51-2.718.955-9.11-4.32-6.179-7.035z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AE283E",
    d: "M90.472 23.118s.216 3.008 1.65 4.025c1.434 1.017 3.933-.15 4.035-2.115.103-1.965-.8-4.88-1.339-5.137-.53-.256-4.346 3.227-4.346 3.227z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EC6265",
    d: "M96.3 18.267s.249-1.734.809-1.672c.56.066.406 3.011-.447 3.04-.849.03-.362-1.368-.362-1.368zM88.299 18.984s-.593-1.65-1.24-1.452c-.648.197.043 3.07 1.05 2.89 1.002-.18.19-1.438.19-1.438z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EC6265",
    d: "M88.467 14.58s6.249-2.16 7.405.186c1.156 2.345.882 6.695.183 8.264-1.061 2.386-4.544 2.697-6.49.6-1.753-1.884-3.322-7.569-1.098-9.05z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M91.368 21.443s2.2-.194 2.814-.52c0 0-.267 1.17-1.182 1.31-.918.139-1.632-.79-1.632-.79z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DADADA",
    d: "M103.54 24.695c-.925-.216-1.844-.399-2.755-.556 1.365 4.873 6.154 22.343 6.611 29.557.513 8.064-2.341 27.758-4.02 38.393 4.496 1.716 9.67 3.959 13.207 5.532 1.987.881 4.222-.571 4.218-2.744-.01-12.703-.04-47.4.004-53.049.062-8.576-3.618-13.954-17.265-17.133z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001437",
    d: "M88.968 15.724s.995.447 2.967.238c1.972-.208 2.203-.98 2.81-1.086.607-.106 1.112 1.214 1.237 2.012.128.797-.026 2.063.377 1.741.402-.322.417-.83.548-1.57.128-.742.297-4.679-.534-5.597-.83-.918-3.22-1.295-3.22-1.295s-1.953-1.057-3.46-.015c-1.508 1.047-3.564 2.547-3.684 3.25-.121.702 1.1 5.586 2.078 6.124.976.537-1.021-4.08.881-3.802z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#211B40",
    d: "M112.511 39.245s3.527 13.211 8.272 20.246c0-5.535.004-10.467.01-13.836l-8.282-6.41z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EC6265",
    d: "M74.795 21.955S48.728 45.07 51.175 56.879c2.452 11.81 13.38 4.712 16.08.63 2.7-4.083 11.62-32.327 10.741-33.846-.874-1.518-3.2-1.708-3.2-1.708zM111.541 29.649c4.336-6.26 38.159 17.996 41.455 35.802 3.655 19.734-32.978 39.48-35.802 36.556-2.828-2.92 19.599-29.678 19.599-33.731 0-6.421-31.413-29.726-25.252-38.627z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AE283E",
    d: "M153 65.455c-2.239-12.095-18.56-27.161-30.157-33.622.955 3.337 3.64 10.405 10.185 15.626 8.857 7.068 16.961 12.812 16.394 20.067-.567 7.254-4.994 6.5-11.213 16.394-6.22 9.892-19.6 14.7-20.353 17.806-.047.19-.03.376.044.552 5.802.611 38.565-18.11 35.1-36.823z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001437",
    d: "M133.043 62.012c3.19-4.16 7.478-13.244 7.478-13.244l-13.171 6.995c2.115 2.243 4.098 4.365 5.693 6.25z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EC6265",
    d: "M118.943 98.846c-.216-.592-.502-1.148-.85-1.672-.694-1.05-2.044-2.831-3.306-3.018-1.804-.267-5.909.926-5.324 1.368.586.443 4.285.026 4.285.026s-3.911 1.518-4.621 2.52c-.71 1.003.893 2.346 1.928 2.565 1.035.22 5.799 2.206 7.558 1.603 1.193-.414.74-2.258.33-3.392z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M141.337 46.434c-11.294-11.791-26.942-20.908-29.796-16.785-4.408 6.366 8.166 20.773 16.961 30.431 2.986-1.81 11.302-6.907 12.835-13.646z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DADADA",
    d: "M141.337 46.434c-9.143-9.545-21.136-17.338-26.89-17.77 4.196 3.019 13.76 10.193 17.55 15.465 2.374 3.3 4.302 6.44 5.663 8.81 1.723-1.913 3.131-4.105 3.677-6.505z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AE283E",
    d: "M68.294 48.304c-2.942 6.526-5.572 8.696-9.516 9.329-3.41.549-6.048-.83-7.727-1.665.026.311.066.615.128.911 2.451 11.81 13.38 4.712 16.08.63 2.18-3.293 8.403-22.31 10.265-30.333-1.628 3.622-6.215 14.44-9.23 21.128z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLandingStarterQuiz2);
export default __webpack_public_path__ + "static/media/landing-starter-quiz-2.8baf6ad423a763f25a2a8f144db461fe.svg";
export { ForwardRef as ReactComponent };